var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7934 49.9031C38.4864 49.9031 49.5868 38.8028 49.5868 25.1098C49.5868 11.4167 38.4864 0.31636 24.7934 0.31636C11.1004 0.31636 0 11.4167 0 25.1098C0 38.8028 11.1004 49.9031 24.7934 49.9031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63785 25.1725V21.1022H22.7596V16.9136H9.63785V12.8438H39.9511V16.9136H26.8315V21.1017H39.9511V25.1723H26.8315L40.004 44.7872C45.8364 40.2516 49.5884 33.1678 49.5884 25.2074C49.5884 11.5134 38.4874 0.413223 24.7939 0.413223C11.1011 0.413661 0 11.5136 0 25.2076C0 33.1676 3.75146 40.2518 9.58413 44.7872L22.7592 25.1725H9.63785Z",
    fill: "#E3232C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9893 47.0157C16.4995 48.9186 20.5209 50 24.7941 50C29.0679 50 33.0885 48.9178 36.5991 47.0157L24.7941 29.4314L12.9893 47.0157Z",
    fill: "#E3232C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSora);
export default __webpack_public_path__ + "static/media/sora.88d3b0c098b68ce693fd86d6c7ecbfe8.svg";
export { ForwardRef as ReactComponent };